import React from 'react';
import clsx from 'clsx';

import Tr from '../../../../components/common-table/components/Tr';
import Td from '../../../../components/common-table/components/Td';
import CommonCheckbox from '../../../../components/common-checkbox/CommonCheckbox';
import CommonIconButton from '../../../../components/common-icon-button/CommonIconButton';
import { ICONS } from '../../../../icons';

import scss from './ProjectsTable.module.scss';

function ProjectTableItem({ data, onEnable, onDelete }) {
  const { actionedOn, lastUsage, actionedBy, enabled, projectName } = data;

  const handleEnable = () => {
    onEnable(data);
  };

  const handleDelete = () => {
    onDelete(data);
  };

  return (
    <Tr>
      <Td isLeft>
        <span className={scss.cellUser}>{projectName}</span>
      </Td>
      <Td isLeft extraClasses={clsx(!enabled && scss.cellDeactivated)}>
        {actionedOn}
      </Td>
      <Td isLeft extraClasses={clsx(!enabled && scss.cellDeactivated)}>
        {actionedBy}
      </Td>
      <Td isLeft extraClasses={scss.cellLastUsage}>
        {lastUsage}
      </Td>
      <Td extraClasses={scss.cellEnable}>
        <CommonCheckbox checked={enabled} onChange={handleEnable} />
      </Td>
      <Td isLeft extraClasses={scss.cellAction}>
        <CommonIconButton icon={ICONS.Delete} onClick={handleDelete} />
      </Td>
    </Tr>
  );
}

export default ProjectTableItem;
